import { logError } from '@seo/logger';

export const logThematicError = (error: Error, theme: string, brand: string, country: string, url: string) => {
  const newRelicObject = {
    eventName: 'thematic',
    theme,
    brand,
    country,
    url,
    errorMessage: error.message || error.errorMessage,
    status: error.statusCode || error.status,
    type: error.type || '',
    log: error.log || '',
    requestId: error.requestId || ''
  };

  logError(error, newRelicObject);
};
